import React from 'react';
import ListProduct from '../ListProduct';

import styles from './styles.module.css';

const ListProducts = ({data}) => {
  const {allMdx} = data;
  return (
    <div className={styles.products}>
      {allMdx.nodes.map(e => (
        <ListProduct key={e.id} product={e} />
      ))}
    </div>
  );
};

export default ListProducts;
